import {
  APPOINTMENT_FLOW,
  APPOINTMENT_STATUS_LABELS,
  type AppointmentStatus,
} from "@shared/modules/x-atelier";
import { Icon } from "../../../core/components/ui/icon";

interface StatusStepperProps {
  status: AppointmentStatus;
  disabled?: boolean;
  onSelect: (status: AppointmentStatus) => void;
}

/**
 * Frise du cycle de vie d'un travail. Chaque étape est un bouton : le
 * technicien tape celle qu'il vient d'atteindre (ou revient en arrière s'il
 * s'est trompé). Hors parcours (devis, annulé, non présenté), rien n'est
 * marqué atteint — l'en-tête de la fiche explique alors la situation.
 */
export function StatusStepper({ status, disabled = false, onSelect }: StatusStepperProps) {
  const current = APPOINTMENT_FLOW.indexOf(status);
  return (
    <ol className="stepper" aria-label="Étapes du travail">
      {APPOINTMENT_FLOW.map((step, i) => {
        const state = i < current ? "done" : i === current ? "current" : "todo";
        return (
          <li key={step} className={`stepper__step stepper__step--${state}`}>
            <button
              type="button"
              className="stepper__btn"
              disabled={disabled || state === "current"}
              aria-current={state === "current" ? "step" : undefined}
              onClick={() => onSelect(step)}
            >
              <span className="stepper__dot" aria-hidden="true">
                {state === "done" ? <Icon name="check" size={14} /> : i + 1}
              </span>
              <span className="stepper__label">{APPOINTMENT_STATUS_LABELS[step]}</span>
            </button>
          </li>
        );
      })}
    </ol>
  );
}
